import { useState } from 'react';
import { Link } from 'react-router-dom';
import { aboutData } from '@/mocks/comics';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);
    const hpVal = (formData.get('website_alt') as string || '').trim();
    if (hpVal) {
      setSubmitStatus('success');
      setEmail('');
      return;
    }
    try {
      const res = await fetch('http://vktest.com/api/form/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      if (res.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    }
  };

  const navLinks = [
    { name: '首页', path: '/' },
    { name: '恋爱漫画', path: '/category/love' },
    { name: '悬疑漫画', path: '/category/suspense' },
    { name: '奇幻漫画', path: '/category/fantasy' },
    { name: '都市漫画', path: '/category/urban' },
    { name: '动作漫画', path: '/category/action' },
    { name: '关于我们', path: '/about' },
  ];

  const policyLinks = [
    { name: '隐私政策', path: '/privacy' },
    { name: '服务条款', path: '/terms' },
    { name: '免责声明', path: '/disclaimer' },
  ];

  return (
    <footer className="bg-foreground-900 text-background-50 mt-14 md:mt-20">
      <div className="mx-4 md:mx-6 rounded-2xl bg-foreground-900">
        <div className="px-6 md:px-10 py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
              <h3 className="font-heading text-2xl font-bold mb-3">订阅更新</h3>
              <p className="text-foreground-300 text-sm mb-6 leading-relaxed">
                订阅我们的邮件，第一时间获取最新韩漫更新通知和独家推荐。
              </p>
              <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入您的邮箱地址"
                  required
                  className="flex-1 bg-transparent border-b border-foreground-600 text-background-50 text-sm py-2 px-1 outline-none focus:border-primary-400 transition-colors placeholder:text-foreground-500"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="hp-field"
                />
                <button
                  type="submit"
                  className="px-6 py-2 bg-background-50 text-foreground-900 rounded-full text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  订阅 <i className="ri-arrow-right-line ml-1"></i>
                </button>
              </form>
              {submitStatus === 'success' && (
                <p className="text-secondary-400 text-xs mt-2">订阅成功！感谢您的关注。</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-accent-400 text-xs mt-2">订阅失败，请稍后再试。</p>
              )}
            </div>

            <div className="md:col-span-3">
              <h4 className="font-heading text-sm font-semibold mb-4 text-foreground-200">快速导航</h4>
              <ul className="space-y-2">
                {navLinks.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-foreground-400 text-sm hover:text-background-50 transition-colors border-b border-transparent hover:border-foreground-500 pb-0.5 cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-4">
              <h4 className="font-heading text-sm font-semibold mb-4 text-foreground-200">联系我们</h4>
              <div className="space-y-3 text-foreground-400 text-sm">
                <p className="flex items-center gap-2">
                  <i className="ri-phone-line text-foreground-500"></i>
                  {aboutData.contact.phone}
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-mail-line text-foreground-500"></i>
                  {aboutData.contact.email}
                </p>
              </div>
              <div className="mt-6">
                <h4 className="font-heading text-sm font-semibold mb-3 text-foreground-200">地址</h4>
                <p className="text-foreground-400 text-sm leading-relaxed">{aboutData.contact.address}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 px-6 md:px-10 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-6">
              {aboutData.socialLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.url}
                  className="text-foreground-400 hover:text-background-50 transition-colors border-b border-transparent hover:border-foreground-500 pb-0.5 text-sm cursor-pointer"
                  rel="nofollow"
                >
                  <i className={`${link.icon} mr-1`}></i>
                  {link.name}
                </a>
              ))}
            </div>
            <p className="text-foreground-500 text-xs">
              &copy; {new Date().getFullYear()} 韩漫漫画网 HanManMH.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              {policyLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-foreground-400 hover:text-background-50 transition-colors border-b border-transparent hover:border-foreground-500 pb-0.5 text-xs cursor-pointer"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}